export default {
      id: "ic-plan-jeunesse-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-jeunesse-usage",
      toString: function () {
        return this.url;
      }
    }